export default __webpack_public_path__ + "static/media/eltesoroG.f5a8810d.png";